import { Check } from "lucide-react";

const points = [
  "Cover starts the moment you place your order",
  "Damage is covered after delivery, during normal personal use",
  "Repair, replacement or store credit",
  "No cash settlement",
];

export default function PlanCovers() {
  return (
    <section className="tw-bg-white">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-[45%_55%]">
        {/* Image */}
        <div className="tw-relative tw-h-96 md:tw-h-auto md:tw-min-h-[640px] tw-bg-[#1c1c1c]">
          <img
            src="/izicart/ad-action-camera.jpg"
            alt="IZI One Lite action camera"
            className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
          />
        </div>

        {/* Text */}
        <div className="tw-flex tw-items-center tw-px-6 tw-py-16 md:tw-px-[85px] md:tw-py-0">
          <div>
            <h2 className="tw-text-3xl md:tw-text-[36px] tw-font-semibold tw-leading-tight tw-text-black">
              What your plan covers
            </h2>

            {/* line breaks follow the design on xl+ (column is too narrow below); text wraps freely there */}
            <p className="tw-mt-5 tw-text-base tw-leading-7 tw-text-gray-500 xl:[&>span]:tw-block xl:[&>span]:tw-whitespace-nowrap">
              <span>The IZI Accidental Plan works alongside your manufacturer’s warranty: </span>
              <span>defects stay with the manufacturer, and accidental damage to the main </span>
              <span>device unit is covered by the plan.</span>
            </p>

            <ul className="tw-mt-8 tw-space-y-4">
              {points.map((point) => (
                <li
                  key={point}
                  className="tw-flex tw-items-center tw-gap-3 tw-text-[15px] tw-text-gray-800"
                >
                  <span className="tw-flex tw-items-center tw-justify-center tw-w-[18px] tw-h-[18px] tw-shrink-0 tw-rounded-full tw-bg-green-100">
                    <Check size={11} strokeWidth={3} className="tw-text-green-600" />
                  </span>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
